<script lang="ts" setup>
definePageMeta({
  validate: validateAndCacheEntity('artist', fetchArtistBySlug),
  authType: 'public',
  layoutProps: {
    invertNavbar: true,
  },
})

const slugId = computed(() => useSlugId().value._unsafeUnwrap())
const { data: artist, suspense } = useArtistBySlug(slugId)
onServerPrefetch(async () => {
  await suspense()
})
</script>

<template>
  <div v-if="artist">
    <AlArtistHeader :artist="artist" />

    <AlCmsPageSection
      v-for="section of artist.cms_page_section"
      :key="section.id"
      :section="section"
    />

    <AlArtistPageShowcase :artist="artist" />
  </div>
  <div v-else />
</template>
